<template>
  <v-container>
    <h1>{{ repo }}</h1>
    <Repo
      v-if="currentAuthorizationToken"
      :auth="currentAuthorizationToken"
      :repo
    />
    <div v-else>Error: <router-link to="home">log in</router-link></div>
  </v-container>
</template>
<script setup lang="ts">
import { currentAuthorizationToken } from "../authenticationTokens";
defineProps<{
  repo: string;
}>();
</script>
